import { FileService } from "src/backend/openapi/v1";

export const baseUrl = process.env.API_BASE_URL;

export const getFileUrl = (fileId: string) =>
  FileService.getApiV1Files
    .toString()
    .replace(/[\s\S]+url: ?['"](.*?)['"][\s\S]+/, "$1")
    .replace(/{.*}/, fileId);

export const getFilePreviewUrl = (fileId: string) =>
  FileService.getApiV1FilesPreview
    .toString()
    .replace(/[\s\S]+url: ?['"](.*?)['"][\s\S]+/, "$1")
    .replace(/{.*}/, fileId);
